export enum CustomerModalState {
  AddContactPerson = 'addContactPerson',
  Company = 'company',
  EditContactPerson = 'editContactPerson',
  Individual = 'individual',
}
